import { render, staticRenderFns } from "./VisitorCalls.vue?vue&type=template&id=1bbfcd45&scoped=true"
import script from "./VisitorCalls.vue?vue&type=script&lang=js"
export * from "./VisitorCalls.vue?vue&type=script&lang=js"
import style0 from "./VisitorCalls.vue?vue&type=style&index=0&id=1bbfcd45&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbfcd45",
  null
  
)

export default component.exports